
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMotorOnVertical as ObiMotorOnVerticalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-motor-on-vertical.js';
 
 
 

 
 export const ObiMotorOnVertical = createComponent({
   react: React,
   tagName: 'obi-motor-on-vertical',
   elementClass: ObiMotorOnVerticalElement,
   events: {
     
   }
  });
 
 